// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"382":"86ce562d","787":"20be73a5","894":"541163c9"}[chunkId] + ".chunk.js";
};